import Dropzone from "react-dropzone";
import { useState } from "react";
import { Paper } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import { CloudUpload } from "@mui/icons-material";
import styles from "../Styles/dropzone.module.css";
import { DropzoneComponentProps } from "../Utils/Types";
import genericFile from "../Images/Icons/Generic-icon.png";

export default function DropzoneComponent(props: DropzoneComponentProps) {
  const [files, setFiles] = useState<any[]>(props.paths || []);

  /**
   * Render the list of uploaded files
   */
  const renderFiles = () => {
    return files?.map((file, index) => (
      <div key={index} className={styles.filePreview}>
        <img
          width={75}
          src={props.paths ? file : genericFile}
          alt={props.altText || Vocabulary.profilePicture}
        />
        <p>
          {file?.name
            ? file?.name?.length > 15
              ? `${file.name.substr(0, 15)}...`
              : file.name
            : ""}
        </p>
      </div>
    ));
  };

  return (
    <Dropzone
      accept={props.acceptedFileTypes}
      maxFiles={props.maxFiles}
      maxSize={props.maxSize}
      multiple={props.multiple}
      onDrop={(acceptedFiles: any) => {
        const updatedFiles = [...files, ...acceptedFiles];
        setFiles(updatedFiles);
        props.onSave(acceptedFiles);
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <Paper>
          <div {...getRootProps()} className={styles.dropzoneArea}>
            <input {...getInputProps()} />
            <p>{Vocabulary.dragAndDrop}</p>
            <CloudUpload fontSize="large" />
            {files?.length > 0 && (
              <div className={styles.fileList}>{renderFiles()}</div>
            )}
            <p>{props?.error?.message}</p>
          </div>
        </Paper>
      )}
    </Dropzone>
  );
}
